import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import { formatPhone } from 'utils/helpers/format';
import { ensureProtocol, getHostname } from 'utils/helpers/url';

import styles from './styles.module.scss';

const Contacts = ({ contacts, location }) => {
	const { email, phones, url } = contacts;

	const instituteEmail =
		email &&
		email
			.replace(/\s/g, '')
			.split(/[,;]/)
			.map((itemEmail) => ({
				url: `mailto:${itemEmail}`,
				title: itemEmail,
				target: '_blank',
				rel: 'noopener'
			}));

	const institutePhones = phones?.map((itemPhone) => ({
		url: `tel:${formatPhone(itemPhone.value).replace(
			/[\s\u0028\u0029-]/g,
			''
		)}`,
		title: formatPhone(itemPhone.value, location),
		target: '_blank',
		rel: 'noopener'
	}));

	const instituteUrl =
		url &&
		url.split(/[,;]/).map((itemUrl) => ({
			url: ensureProtocol(itemUrl.trim()),
			title: getHostname(itemUrl.trim()),
			target: '_blank',
			rel: 'nofollow noopener'
		}));

	const renderItem = (contact) => (
		<div className={styles.contactsGroup}>
			{contact.map((item) => (
				<div className={styles.contactsItem} key={item.url}>
					<a
						className={styles.contactsLink}
						href={item.url}
						target={item.target}
						rel={item.rel}
					>
						{item.title}
					</a>
				</div>
			))}
		</div>
	);

	return (
		<div className={styles.contacts}>
			{!_(instituteUrl).isEmpty() || !_(instituteEmail).isEmpty() ? (
				<div className={styles.contactsRow}>
					{!_(instituteUrl).isEmpty() && renderItem(instituteUrl)}
					{!_(instituteEmail).isEmpty() && renderItem(instituteEmail)}
				</div>
			) : null}
			{!_(institutePhones).isEmpty() && (
				<div className={styles.contactsRow}>{renderItem(institutePhones)}</div>
			)}
		</div>
	);
};

Contacts.propTypes = {
	contacts: PropTypes.shape({
		email: PropTypes.string,
		phones: PropTypes.arrayOf(
			PropTypes.shape({
				value: PropTypes.string
			})
		),
		url: PropTypes.string
	}).isRequired,
	location: PropTypes.shape({
		city: PropTypes.string,
		federalSubject: PropTypes.string
	})
};

export default Contacts;
